module.exports = __webpack_public_path__ + "img/bj24.d81a1921.png";